import actions from './actions'

export default {
	namespaced: true,
	actions: actions
}



// WEBPACK FOOTER //
// ./src/vuex/services/worker/index.js